import { PlusIcon, Trash2 } from 'lucide-react'
import { Button } from '@neo/primitives/button'
import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import z from 'zod'
import type { GenericFormType } from '@neo/blocks/forms/types'
import { Tooltip } from '@neo/primitives/tooltip'
import type { AiAgentNodeformData } from '../../types'
import { ActionsForm } from './action-form'
import { actionInitialState } from '../../config/nodes.config'

export const Actions = ({
  form,
  nodeVars = [],
}: {
  form: GenericFormType<AiAgentNodeformData>
  nodeVars?: string[]
}) => (
  <div className="w-full max-w-2xl mx-auto">
    <FieldsRenderer
      fields={[
        {
          name: 'actions',
          type: 'array',
          defaultNewValue: (_, field) => actionInitialState(field.state.value.length),
          className: 'relative',
          removeItemButton: (
            <Tooltip content="Remove action">
              <Button
                variant="ghostDestructive"
                className="absolute right-8 top-2"
                type="button"
                size="iconSm"
                aria-label="Remove action"
              >
                <Trash2 size={16} />
              </Button>
            </Tooltip>
          ),
          addItemButton: (props) => (
            <div>
              <Button
                className="flex items-center mt-4 form-button"
                variant="ghost"
                type="button"
                {...props}
              >
                <PlusIcon className="h-4 w-4 mr-2" />
                Define Actions
              </Button>
            </div>
          ),
          subFields: [
            {
              name: '',
              type: 'sub-item',
              component: (props) => (
                <ActionsForm form={props.form} arrayIndex={props.arrayIndex} nodeVars={nodeVars} />
              ),
              zodValidation: z.any(),
              eventDataExtractor: (data) => data as Record<string, unknown>,
            },
          ],
        },
      ]}
      form={form}
    />
  </div>
)
